import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import AlertIcon from './AlertIcon';
import {CustomText} from '../../../components/core/text';
import {HBox} from '../../../components/core/view';
import React from 'react';
import {StyleSheet} from 'react-native';

interface AlertTextBoxProps {
  title: string;
}

const AlertTextBox = (props: AlertTextBoxProps) => {
  const theme = useColorThemeType('main');
  const muliFont = useFontTheme('muli');

  return (
    <HBox
      style={[
        {backgroundColor: theme?.background.white[100]},
        styles.container,
      ]}>
      <AlertIcon
        viewBox="0 -4 23 23"
        height={25}
        width={25}
        fill={theme?.text?.red[100]}
      />
      <CustomText
        style={[
          {color: theme?.text?.red[100], fontFamily: muliFont[700].normal},
          styles.headerTypo,
        ]}>
        {props.title}
      </CustomText>
    </HBox>
  );
};

export default React.memo(AlertTextBox);

const styles = StyleSheet.create({
  headerTypo: {
    textAlign: 'left',
    paddingRight: 10,
  },
  container: {
    marginBottom: 15,
    marginLeft: 10,
    paddingRight: 15,
    justifyContent: 'flex-start',
    width: '95%',
  },
});
